import { ref, onUnmounted } from 'vue';

export function useAutoScroll(options = {}) {
  const { intervalMs = 4000, scrollAmount = 340 } = options;

  const sliderRef = ref(null);
  const isPaused = ref(false);
  let autoScrollTimer = null;

  const scrollSlider = (direction) => {
    if (!sliderRef.value) return;

    if (direction === 'left') {
      sliderRef.value.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
    } else {
      sliderRef.value.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    }
    startAutoScroll();
  };

  const startAutoScroll = () => {
    stopAutoScroll();

    if (!sliderRef.value) return;

    autoScrollTimer = setInterval(() => {
      if (isPaused.value) return;

      const { scrollLeft, scrollWidth, clientWidth } = sliderRef.value;

      if (scrollLeft + clientWidth >= scrollWidth - 10) {
        sliderRef.value.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        sliderRef.value.scrollBy({ left: scrollAmount, behavior: 'smooth' });
      }
    }, intervalMs);
  };

  const stopAutoScroll = () => {
    if (autoScrollTimer) {
      clearInterval(autoScrollTimer);
      autoScrollTimer = null;
    }
  };

  const pause = () => {
    isPaused.value = true;
  };

  const resume = () => {
    isPaused.value = false;
  };

  onUnmounted(() => {
    stopAutoScroll();
  });

  return {
    sliderRef,
    isPaused,
    scrollSlider,
    startAutoScroll,
    stopAutoScroll,
    pause,
    resume,
  };
}
